import {connect} from 'react-redux';
import {selectTemplateCategory} from 'template/actions';
import React, {Component} from 'react';
import {ListGroupItem} from 'reactstrap';

@connect(
    state => ({
        selectedTemplateCategory: state.template.selectedTemplateCategory
    }),
    dispatch => {
        return {
            select: (category) => dispatch(selectTemplateCategory(category)),
        }
    }
)
export default class TemplateCategory extends Component {
    render() {
        const {
            templateCategory,
            select,
            selectedTemplateCategory,
            index
        } = this.props;
        return (
            <ListGroupItem
                onClick={() => select(templateCategory)}
                className='btn btn-link text-left'
                active={selectedTemplateCategory && selectedTemplateCategory.id === templateCategory.id}
            >
                {index}. {templateCategory.name}
            </ListGroupItem>
        )
    }
}
